module.exports = __webpack_public_path__ + "static/media/tradicional.4f85bd8c.png";